import type { ReportHistoryPersonRecipientType as ApiReportHistoryPersonRecipientType } from 'src/api/generated/touring/types';
import type { ReportHistoryPersonRecipientType } from '../../types';

export const mapReportHistoryPersonRecipientType = (
  api: ApiReportHistoryPersonRecipientType
): ReportHistoryPersonRecipientType => ({
  id: api.id,
  firstname: api.firstname,
  lastname: api.lastname,
  email: api.email,
});
